import { Injectable } from '@angular/core';
import { CompanyService } from './company.service';
@Injectable({ providedIn: 'root' })
export class FinanceService {
  private readonly companyRoute = 'company';

  constructor(private companyService: CompanyService) {}

  getCompanyFilters(isAllVisible?: boolean) {
    return this.companyService.getCompanyFilters(isAllVisible);
  }
}
